/**
 * Reusable modal for handling unsaved changes
 * Eliminates duplication between save/switch and save/back modals
 */

import { FC } from "react";
import { Button, Modal, Text } from "@mantine/core";

interface UnsavedChangesModalProps {
  opened: boolean;
  onClose: () => void;
  onSave: () => void;
  onDiscard: () => void;
  actionText: string; // "switching tabs" or "going back"
  saveButtonText: string; // "Save and Switch" or "Save and Go Back"
  discardButtonText: string; // "Discard and Switch" or "Discard and Go Back"
}

/**
 * Unified modal for unsaved changes warnings
 * Handles both tab switching and navigation scenarios
 */
export const UnsavedChangesModal: FC<UnsavedChangesModalProps> = ({
  opened,
  onClose,
  onSave,
  onDiscard,
  actionText,
  saveButtonText,
  discardButtonText,
}) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Unsaved Changes"
      styles={{
        title: { fontWeight: 700 },
      }}
    >
      <Text>
        You have unsaved changes. Do you want to save them before {actionText}?
      </Text>
      <div style={{ marginTop: "20px", display: "flex", gap: "10px" }}>
        <Button onClick={onSave}>{saveButtonText}</Button>
        <Button onClick={onDiscard} variant="outline">
          {discardButtonText}
        </Button>
        <Button onClick={onClose} variant="outline">
          Cancel
        </Button>
      </div>
    </Modal>
  );
};
